import { CloseButtonSvg } from '@/components/SvgComponents/CloseButtonSvg'
import { dialogRegisterQuestionnaireState } from '@/features/dialogSlice'
import type { RootState } from '@/store/store'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import type React from 'react'
import { memo, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

type Props = {
  children: React.ReactNode
  title?: string
  description?: string
  image?: string
  closeButtonOff?: boolean
}

const DialogRegisterQuestionnaire = memo(({ children, title, description, image, closeButtonOff }: Props) => {
  const dialogRegisterQuestionnaireStateSelector = useSelector(
    (state: RootState) => state.dialog.dialogRegisterQuestionnaireState,
  )
  const dispatch = useDispatch()
  const dialogElem = useRef(null)

  useEffect(() => {
    if (dialogRegisterQuestionnaireStateSelector) {
      disableBodyScroll(dialogElem.current)
      return
    }

    enableBodyScroll(dialogElem.current)
    return
  }, [dialogRegisterQuestionnaireStateSelector])

  const CloseButton = () => {
    enableBodyScroll(dialogElem.current)
    dispatch(dialogRegisterQuestionnaireState(false))
  }

  return (
    <article className="c-dialog" id="my-dialog" aria-hidden={!dialogRegisterQuestionnaireStateSelector}>
      <div className="c-dialog-overlay" onClick={() => CloseButton()} />
      <div className="c-dialog-wrap">
        {closeButtonOff ? (
          ''
        ) : (
          <button
            type="button"
            className="c-dialog-close"
            aria-label="dialog close button"
            onClick={() => CloseButton()}
          >
            <CloseButtonSvg />
          </button>
        )}
        <div role="dialog" className="c-dialog-content" aria-labelledby="dialog" ref={dialogElem}>
          {title && (
            <h1
              className="text-gray-600 text-center text-h1 font-bold"
              dangerouslySetInnerHTML={{
                __html: title,
              }}
            />
          )}

          {description && (
            <p
              className="text-gray-600 mt-5 text-center text-sm font-bold"
              dangerouslySetInnerHTML={{
                __html: description,
              }}
            />
          )}

          {children}
        </div>
      </div>
    </article>
  )
})

export default DialogRegisterQuestionnaire
